import { gql, useMutation } from '@apollo/client'

import { UpdatePreferenceDocument } from '@/graphql/purchase-plus/generated/updatePreference.generated'
import { PURCHASE_PLUS_GRAPHQL_API } from '@/modules/shared/constants'

const PREFERENCE_FRAGMENT = gql`
  fragment PreferenceFragment on Preference {
    key
    value
  }
`

export default function useUpdatePreference() {
  const mutation = useMutation(UpdatePreferenceDocument, {
    context: { uri: PURCHASE_PLUS_GRAPHQL_API },
    update: (cache, { data }) => {
      const preference = data?.updatePreference?.preference
      if (preference) {
        // Write the updated preference to the normalized cache
        cache.writeFragment({
          id: cache.identify({ __typename: 'Preference', key: preference.key }),
          fragment: PREFERENCE_FRAGMENT,
          data: preference,
        })
      }
    },
  })

  return mutation
}
